"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _selectTable = _interopRequireDefault(require("react-table/lib/hoc/selectTable"));

var _ = _interopRequireDefault(require("./"));

var _ActionButtons = _interopRequireDefault(require("./ActionButtons"));

var _UncontrolledCheckbox = _interopRequireDefault(require("../Checkbox/UncontrolledCheckbox"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var WrappedTable = (0, _selectTable.default)(_.default);

var CheckboxInput = function CheckboxInput(props) {
  return _react.default.createElement(_UncontrolledCheckbox.default, {
    id: "".concat(props.id),
    checked: props.checked,
    onChange: function onChange() {
      props.onClick(props.id, null, props.row);
    },
    withPadding: false
  });
};

var CheckboxTable =
/*#__PURE__*/
function (_Component) {
  _inherits(CheckboxTable, _Component);

  function CheckboxTable() {
    var _this;

    _classCallCheck(this, CheckboxTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CheckboxTable).call(this));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleSelection", function (key) {
      // start off with the existing state
      var selection = _toConsumableArray(_this.state.selection);

      var keyIndex = selection.indexOf(key); // check to see if the key exists

      if (keyIndex >= 0) {
        // it does exist so we will remove it using destructing
        selection = _toConsumableArray(selection.slice(0, keyIndex)).concat(_toConsumableArray(selection.slice(keyIndex + 1)));
      } else {
        // it does not exist so add it
        selection.push(key);
      } // update the state


      var toggleSelectionCallBack = _this.props.toggleSelectionCallBack;

      if (toggleSelectionCallBack) {
        toggleSelectionCallBack({
          selection: selection
        });
      }

      _this.setState({
        selection: selection
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleAll", function () {
      var all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false; // Quick escape to reset all

      var toggleAllCallback = _this.props.toggleAllCallback;

      if (all) {
        // hook for additional actions outside the component
        if (toggleAllCallback) {
          toggleAllCallback({
            selectAll: false,
            selection: []
          });
        }

        _this.setState({
          selectAll: false,
          selection: []
        });

        return;
      }
      /*
        Only select ALL the records that are in the current filtered data?
         We'll access our Table's 'ref' and then get the internal state and the 'sortedData'.
        That can then be iterated to get all the currently visible records and set
        the selection state.
      */


      var selectAll = _this.state.selectAll ? false : true;
      var selection = [];

      if (selectAll) {
        // we need to get at the internals of ReactTable
        var wrappedInstance = _this.checkboxTable.innerTable; // the 'sortedData' property contains the currently accessible records based on the filter and sort

        var currentRecords = wrappedInstance.getResolvedState().sortedData; // we just push all the IDs onto the selection array

        currentRecords.forEach(function (item) {
          selection.push(item._original.id);
        });
      } // hook for additional actions outside the component


      if (toggleAllCallback) {
        toggleAllCallback({
          selectAll: selectAll,
          selection: selection
        });
      }

      _this.setState({
        selectAll: selectAll,
        selection: selection
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isSelected", function (key) {
      /*
        Instead of passing our external selection state we provide an 'isSelected'
        callback and detect the selection state ourselves. This allows any implementation
        for selection (either an array, object keys, or even a Javascript Set object).
      */
      return _this.state.selection.includes(key);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderActionButtons", function () {
      var actions = _this.props.actions;
      var selection = _this.state.selection;
      return _react.default.createElement(_ActionButtons.default, {
        actions: actions,
        selection: selection
      });
    });

    _this.state = {
      selection: [],
      selectAll: false
    };
    return _this;
  }

  _createClass(CheckboxTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          actions = _this$props.actions,
          style = _this$props.style,
          rest = _objectWithoutProperties(_this$props, ["actions", "style"]);

      var selectAll = this.state.selectAll;
      var checkboxProps = {
        keyField: "id",
        selectAll: selectAll,
        isSelected: this.isSelected,
        toggleSelection: this.toggleSelection,
        toggleAll: this.toggleAll,
        selectType: "checkbox",
        selectWidth: 36,
        SelectInputComponent: CheckboxInput,
        SelectAllInputComponent: CheckboxInput
      };
      return _react.default.createElement("div", {
        style: _objectSpread({
          width: "100%"
        }, style)
      }, actions && actions.length > 0 && this.renderActionButtons(), _react.default.createElement(WrappedTable, _extends({
        innerRef: function innerRef(r) {
          return _this2.checkboxTable = r;
        }
      }, checkboxProps, rest)));
    }
  }]);

  return CheckboxTable;
}(_react.Component);

var _default = CheckboxTable;
exports.default = _default;